import { render } from "./DownloadSshKey.vue?vue&type=template&id=c8b665d4"
import script from "./DownloadSshKey.vue?vue&type=script&lang=js"
export * from "./DownloadSshKey.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__